export default __webpack_public_path__ + "static/media/docker.a1370972.svg";